import { render, staticRenderFns } from "./TouristsKidAge.vue?vue&type=template&id=9ad7b79a"
import script from "./TouristsKidAge.vue?vue&type=script&lang=js"
export * from "./TouristsKidAge.vue?vue&type=script&lang=js"
import style0 from "./TouristsKidAge.vue?vue&type=style&index=0&id=9ad7b79a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports